import { render, staticRenderFns } from "./BdOnline.vue?vue&type=template&id=02c2c170&"
import script from "./BdOnline.vue?vue&type=script&lang=js&"
export * from "./BdOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports